import { Typography } from '@mui/material';
import { BaseActivityItem } from '../BaseActivityItem';
import { BaseNoteActivityItemProps } from './BaseNote.component';
import { EditOutlined } from '@mui/icons-material';
import { useUserDisplayNameQuery } from '@uplift/queries';

export const ClaimCorrectionNoteActivityItem: React.VFC<BaseNoteActivityItemProps> = props => {

  const coderId = props.note.additionalDetails?.coderId;
  const { data: coderName } = useUserDisplayNameQuery(coderId, { enabled: !!coderId });
  const firstInitial = coderName?.first.charAt(0);

  return (
    <BaseActivityItem
      onClick={props.onClick}
      title={<Typography>Claim Correction Note</Typography>}
      icon={EditOutlined}
      rightContent={(
        <Typography variant="body2" color="textPrimary">
          {`added by ${firstInitial}. ${coderName?.last}`}
        </Typography>
      )}
    />
  );

};
